module.exports = __webpack_public_path__ + "img/BX+.964207e7.png";